import { Paragraph } from 'docx'
import {
  DraftQuestionItem,
  DraftQuestionnaireEntry
} from '../../data/model/questionnaire'
import { isItemHiddenInMarket } from './marketFilter'
import { MAXDIFF_LABEL_NAMES } from './model'

// Labels are written as "<name>: <text>" and read back by name, not position.
export const createEntryContentMaxDiff = (
  entry: DraftQuestionnaireEntry,
  marketSurveyId?: string
): Paragraph[] => {
  const entryItem = entry.entryItem as DraftQuestionItem
  const paragraphs: Paragraph[] = []

  entryItem.responseOptions.forEach((option, index) => {
    const value = option.responseOption?.value
    if (
      value &&
      !isItemHiddenInMarket(option.hiddenInMarkets, marketSurveyId)
    ) {
      paragraphs.push(new Paragraph(`${index + 1}. ${value}`))
    }
  })

  const spec = entryItem.maxDiffSpecification
  if (spec) {
    const labels = [
      [MAXDIFF_LABEL_NAMES.mostLabel, spec.mostLabel.text],
      [MAXDIFF_LABEL_NAMES.leastLabel, spec.leastLabel.text],
      [MAXDIFF_LABEL_NAMES.attributeLabel, spec.attributeLabel.text]
    ] as const
    labels.forEach(([name, text]) => {
      if (text) paragraphs.push(new Paragraph(`${name}: ${text}`))
    })
  }

  return paragraphs
}
